import AsyncStorage from '@react-native-async-storage/async-storage';

import Api, { apiToken } from '../services/Api';

const isSignedIn = () => {
    return new Promise(async (resolve, reject) => {
        const dsToken = await AsyncStorage.getItem('token');

        if (dsToken !== null) {
            const valida = true,
                body = {
                    dsToken
                },
                response = await apiToken(body, valida);

            if (response && response.status === 200) {
                resolve(true);
            } else {
                resolve(false);
            }
        } else {
            resolve(false);
        }
    });
};

const loginAuth = async ({ username, password }) => {
    const body = {
        ds_client: 'gestou',
        ds_login: username,
        ds_senha: password,
        ds_provedor_autenticacao: 'senha',
        ds_secret: '123456'
    };

    const response = await apiToken(body),
        { data } = await response,
        token = data.access_token;

    if (token) {
        await AsyncStorage.setItem('token', token);
        document.cookie = 'Authorization=' + token;
        return token;
    } else {
        throw Error();
    }
};

const getUserDetails = async (token) => {
    const url = 'gestao/loja',
        request = await Api.get(url),
        response = request.data.data;

    const userDetails = {
        token,
        ...response
    };

    await AsyncStorage.setItem('userDetails', JSON.stringify(userDetails));

    return userDetails;
};

export { isSignedIn, loginAuth, getUserDetails };
